(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chak-shipping-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chak-shipping-strip')) {
    customElements.define('chak-shipping-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
